import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Share, PlusSquare } from "lucide-react";

interface InstallInstructionsProps {
  open: boolean;
  onClose: () => void;
}

export function InstallInstructions({ open, onClose }: InstallInstructionsProps) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-center">Install ThePromptSpace</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-6 py-4">
          <p className="text-center text-muted-foreground text-sm">
            To install on your iPhone or iPad:
          </p>
          
          <div className="space-y-4">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center text-primary font-semibold text-sm">
                1
              </div>
              <div className="flex-1">
                <p className="font-medium text-sm">Tap the Share button</p>
                <p className="text-xs text-muted-foreground mt-1">
                  Look for <Share className="inline h-3 w-3" /> at the bottom of Safari
                </p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center text-primary font-semibold text-sm">
                2
              </div>
              <div className="flex-1">
                <p className="font-medium text-sm">Scroll down and tap</p>
                <p className="text-xs text-muted-foreground mt-1 flex items-center gap-1">
                  <PlusSquare className="inline h-3 w-3" /> "Add to Home Screen"
                </p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center text-primary font-semibold text-sm">
                3
              </div>
              <div className="flex-1">
                <p className="font-medium text-sm">Tap "Add"</p>
                <p className="text-xs text-muted-foreground mt-1">
                  ThePromptSpace will appear on your home screen
                </p>
              </div>
            </div>
          </div>
          
          <div className="bg-muted/50 rounded-lg p-3 text-center">
            <p className="text-xs text-muted-foreground">
              Once installed, launch from your home screen for the best experience!
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
